import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PRIMARY_NAV, isActivePath } from '@/lib/navConfig';
import { NavBadge } from './NavBadge';

const ITEMS = PRIMARY_NAV.filter((i) => i.key !== 'transactions');

export const MobileBottomNav = ({ badges }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.add('has-bottom-nav');
    return () => document.body.classList.remove('has-bottom-nav');
  }, []);

  return createPortal(
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80"
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5 h-16">
        {ITEMS.map((item) => {
          const active = isActivePath(pathname, item.to);
          const Icon = item.icon;
          const count = item.badge ? badges?.[item.badge] || 0 : 0;
          return (
            <Link
              key={item.key}
              to={item.to}
              data-testid={`bottom-nav-${item.key}`}
              data-active={active ? 'true' : 'false'}
              className={`relative flex flex-col items-center justify-center gap-0.5 text-[11px] transition-colors ${
                active ? 'text-orange-600 dark:text-orange-400 font-semibold' : 'text-muted-foreground'
              }`}
            >
              <span className={`relative rounded-full px-3 py-0.5 transition-colors ${active ? 'bg-orange-100 dark:bg-orange-900/30' : ''}`}>
                <Icon className="h-5 w-5" />
                <NavBadge count={count} tone={item.badge === 'messages' ? 'blue' : 'red'} className="absolute -top-1 -right-1" testId={`bottom-nav-badge-${item.key}`} />
              </span>
              <span className="truncate max-w-[72px]">{t(item.labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </nav>,
    document.body
  );
};
